export const RESTO365_INGREDIENTS_USED_QUANTITY = 'RESTO365_INGREDIENTS_USED_QUANTITY'

export const RESTO365_INGREDIENTS_USED_QUANTITY_CEREBRO_PRODUCTS = `${RESTO365_INGREDIENTS_USED_QUANTITY}/cerebro-products`

export const RESTO365_INGREDIENTS_USED_QUANTITY_CREATE = `${RESTO365_INGREDIENTS_USED_QUANTITY}/createUsedQuantity`

export const RESTO365_INGREDIENTS_USED_QUANTITY_UPDATE = `${RESTO365_INGREDIENTS_USED_QUANTITY}/updateUsedQuantity`

export const RESTO365_INGREDIENTS_USED_QUANTITY_DELETE = `${RESTO365_INGREDIENTS_USED_QUANTITY}/deleteUsedQuantity`

export const RESTO365_INGREDIENTS_USED_QUANTITY_LIST = `${RESTO365_INGREDIENTS_USED_QUANTITY}/listUsedQuantity`

export const RESTO365_INGREDIENTS_USED_QUANTITY_RESTORE = `${RESTO365_INGREDIENTS_USED_QUANTITY}/restoreUsedQuantity`

export const RESTO365_INGREDIENTS_USED_QUANTITY_SEARCH = `${RESTO365_INGREDIENTS_USED_QUANTITY}/getNutritionalInfo`
